/**
 * 菜单动作路由守卫：按服务端权限快照控制页面访问（URL 直达与左侧菜单同口径）。
 *
 * 判定复用 menuConfig.isMenuVisible，保证「菜单可见 ⇔ URL 可达」：
 * - 快照在身（menuPermissions 权威）：精确模式，合并视图多键（如 ADM-02/04）
 *   任一含 VIEW 即放行；仅持写动作的键不放行（fund-exception-admin-ui:SC-07）。
 * - 快照缺失（未加载/拉取失败）：按岗位兜底，不误锁已登录用户。
 * - 未登记菜单叶子的路径一律拒绝（fail-closed，防止新增页面漏挂守卫）。
 */
import { type ReactNode } from "react";
import { Spin } from "antd";
import { resolveViewMenuKeys } from "../api/auth.api";
import { isMenuVisible, type MenuLeaf } from "../layout/menuConfig";
import { ErrorPage } from "../errors/ErrorPage";
import { useSession } from "./SessionContext";

export interface RequireMenuPermissionProps {
  /** 守卫的菜单叶子；未登记（undefined）一律拒绝 */
  leaf?: MenuLeaf;
  children: ReactNode;
}

export function RequireMenuPermission({ leaf, children }: RequireMenuPermissionProps) {
  const { session, permissions, permissionsLoading } = useSession();

  if (permissionsLoading) {
    return (
      <div data-testid="menu-permission-loading">
        <Spin />
      </div>
    );
  }

  if (
    !leaf ||
    !isMenuVisible(leaf, session?.positions ?? [], resolveViewMenuKeys(permissions))
  ) {
    return <ErrorPage type="forbidden" />;
  }

  return <>{children}</>;
}
